import { Box, Color, Display, DisplayPosition, Space, ZIndex } from '@gousto-internal/citrus-react'
import React from 'react'
import { Background } from './components/Background/Background'
import { Banner } from './components/Banner/Banner'
import { Carousel } from './components/Carousel/Carousel'
import { CTA } from './components/CTA/CTA'

export type LandingPageAboveTheFoldProps = {
  onCTAClick: () => void
  signupCTA: string
}

export function LandingPageAboveTheFold({ onCTAClick, signupCTA }: LandingPageAboveTheFoldProps) {
  return (
    <Box data-testid="landing-page-above-the-fold">
      <Box
        position={DisplayPosition.Relative}
        display={Display.Flex}
        flexBasis={'100%'}
        width={'100%'}
        height={'610px'}
      >
        <Box
          width="100%"
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Mask}
          bottom={['-8px', '16px', null, '158px']}
        >
          <CTA onCTAClick={onCTAClick} signupCTA={signupCTA} />
        </Box>
        <Box
          minHeight={'610px'}
          width="100%"
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Masked}
        >
          <Carousel />
        </Box>
        <Box
          minHeight={'610px'}
          width="100%"
          display={Display.Flex}
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Default}
        >
          <Background />
        </Box>
      </Box>
      <Box position={DisplayPosition.Relative}>
        <Box
          position={DisplayPosition.Absolute}
          top="-1px"
          left="0"
          width="100%"
          height={['60%', null, null, '0%']} // Only display for mobile devices
          bg={Color.ColdGrey_800}
          zIndex={ZIndex.Auto}
        />
        <Space size={6} />
        <Banner />
      </Box>
    </Box>
  )
}
